import { styled } from '@mui/material/styles'
import { Box, Select } from '@mui/material'
import { Link as lnk } from 'react-router-dom'

export const OuterNavSection = styled(Box)(`
  width: 220px;
  box-sizing: border-box;
  border-right: 1px solid #E7E7E6;
  background: #fff;
  display: flex;
  flex-direction: column;
  transition: all 1.0s; // FullScreening
  position: absolute;
  left: 56px;
  height: calc(100vh - 56px);
  z-index: 14;
`)

export const LogoText = styled('img')(`
  // width: 100%;
  max-width: 140px;
  max-height : 30px;
`)

export const ClientDetails = styled(Box)(`
  padding: 0px 12px;
  display: flex;
  flex-direction: column;
  gap:8px;
`)

export const CaseStudy = styled(Box)(`
  height:56px; 
  width: 100%;
  display: flex;
  justify-content: center;
  flex-direction: column;
  gap:4px;
`)

export const PhaseSelectLabel = styled(Box)(`
  color: #21B979;
  font-weight: 600;
  border:1px solid #21B979;
  border-radius: 4px;
  font-size: 14px;
  line-height:28px;
  height: 28px;
  padding: 0 8px;
  border-width: 1px 1px 1px 5px;

  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
`)

export const PhaseSelect = styled(Select)(`
  color: #229a6f;
  font-weight: 600;
  border:1px solid #D8D8D6;
  border-radius: 4px;
  font-size: 14px;
  line-height:20px;
  height: 28px;
  .MuiOutlinedInput-notchedOutline {
    border: none;
  }

  .MuiSelect-select {
    padding-left: 8px;
    padding-right: 8px;
    text-align:start;
  }

  .MuiMenu-paper {
    padding: 0;
  }
`)

export const MenuNavigations = styled('ul')(`
  padding: 3px 12px;
  margin: 0;
  overflow: auto;
  scrollbar-width: none;
  & .hideSandBox { display: none; }
`)

export const MenuListWrapper = styled('li')(`
  list-style: none;
  & .semiTransparent {
    color:red;
    &::after { color:red; }
    &::before { background-color:red; }
  }
`)

export const LogoWrapper = styled(Box)(`
  display:flex;
  padding: 16px 12px 0 12px;
  width: 100%;
  align-items: center;
  justify-content: space-between;
`)

export const MenuList = styled(lnk)(
  ({ active }) => `
  display: flex;
  padding: 6px 24px;
  border-radius: 4px;
  cursor: pointer;
  font-weight: ${active ? 500 : 400};
  background-color: ${active ? '#F6F6F5' : 'transparent'};
  position: relative;
  text-decoration: none;

  font-size: 14px;
  color: #000;
  flex: 1;
  word-break: break-word;
  white-space: normal;
  margin-bottom: 1px;

  &:hover {
    text-decoration: none;
    background-color: #F6F6F5;
    font-weight: 600; // 500;
  }

  &::before {
    content: "";
    width: 8px;
    height: 8px;
    border-radius: 50%;
    background-color: ${active ? '#686867' : '#e7e7e7'};
    position: absolute;
    left: 9px;
    top: 12px;
  }

  &::after {
    content: "${active ? '−' : '+'}";
    font-size: 18px;
    font-weight: 400;
    color: #686867;
    position: absolute;
    right: 9px;
    top: 3px;
  }
`
)

export const MenuListContent = styled(Box)(`
  display: flex;
  flex-direction: column;
  align-items: start;
  margin: 8px 0px;
  padding-left: 20px;
  position: relative;
  list-style: none;

  &::before {
    content: "";
    position: absolute;
    left: 13px;
    top: 10px;
    bottom: 10px;
    width: 1px;
    background-color: #c6c6c6;
  }

  a {
    position: relative;
    font-size: 14px;
    cursor: pointer;
    padding-left: 5px;
    margin-bottom: 8px;
    transition: all 0.2s ease;
    color:#000;
    text-decoration: none;

    &::before {
      content: "";
      position: absolute;
      left: -9px;
      top: 7px;
      width: 5px;
      height: 5px;
      border-radius: 50%;
      background-color: #000;
      opacity: 0;
      transition: opacity 0.2s ease-in-out;
    }

    // Lhs list Bold on hover
    // &:hover {
    //   font-weight: 600; // 500;
    // }

    &:hover::before, &.active::before {
      opacity: 1;
    }

    &.active {
      font-weight: 600;
    }

    &:last-child {
      margin-bottom: 0;
    }

    &.hideSnapshot {
      display:none;
    }
    &.hideBusinessObjective {
      display:none;
    }
  }
`)
